import React, { useEffect, useState } from "react";
import styles from "./scss/contactFrame.module.scss";
import LeftsideBars from "./leftsidebar";
import TopHeader from "../chat/chatsection/topheader";
import { Tooltip } from "antd";
import MainMenus from "../../common/menus";
import ContactFav from "./contactWidgets/contactFavorites";
import ContactTeams from "./contactWidgets/contactTeams";
import ContactNewMem from "./contactWidgets/contactNewmembers";
import { contactService } from "../../base/contactService";
import { useSelector } from "react-redux";
import { initialStateModel } from "../../models/model";
import URContactsListsMainFrame from './contact-details';
import CreateTask from "./rightsidebar/taskcreate";
import TaskViewDetails from "../chat/rightsidebar/taskviewdetails";
import CreateNote from "./rightsidebar/notecreate";
import NoteViewRight from "./rightsidebar/noteview";
import { callMainPageInterface } from "../../models/callModel";
import ToastLeft from "../../shared/widgets/toastScreenleft";
import NewEventRightCreate from "../chat/rightsidebar/neweventright";
import EditEventRightBar from "../chat/rightsidebar/editeventright";
import { ChatService } from "../../base/chatService";
import { useHistory } from "react-router-dom";
import { Cookie, filterFavouriteContacts, Logout } from "../../base/utils";
import store from "../../context/store/store";
import { Types } from "../../context/action/action";
import ToastUndo from "../chat/chatWidgets/toastScreenUndo";
import { SocketChatService } from "../../base/socketChatService";
import { totalTabBatchcount, userInfo } from "../../base/socketChatService/utils";
import { unregister } from "../../base/callService/callService";
import { Meetingnotifications } from "../videonotifications/Meetingnotifications";
import { handelMeetingNotification } from "../../base/socketChatService/newChat";
import contactcenterEmpty from "../../styles/images/contactcenterEmpty.svg";



function URContactsMainFrame() {

  const { toastReducer }: callMainPageInterface = useSelector((state: callMainPageInterface) => state);
  const allReducer: initialStateModel = useSelector((state: initialStateModel) => state);
  let { isContactWindow, contactWindowDetails, isKey, isWindowSlide, editData } = allReducer.contactWindowReducer;
  let { favContacts, allContacs, teamContacs } = allReducer.contactReducer;
  const toastUndo: any = useSelector((state: any) => state.toastReducer);
  //const { TabPane } = Tabs;
  const [isActiveone, setActiveone] = useState(false);
  const initalState: any = useSelector((state: any) => state.serverDisconnectReducer);
  const handleToggle = () => {
    contactService.contactSideWindow(!isWindowSlide, "", {});
    ChatService.saveChatHighlight(false, {});
    ChatService.filesHighlight(false, {});
    //ChatService.saveChatHighlight(false,{});
  };
  let history = useHistory();
  useEffect(() => {

  }, [toastUndo])

  const handleToggleChange = () => {
    contactService.contactSideWindow(false, isKey, editData);
  };

  useEffect(() => {
    let chromeCount: any = totalTabBatchcount();
    document.title = chromeCount > 0 ? "Worktual Web Application (" + chromeCount + ")" : "Worktual Web Application";
  }, []);

  useEffect(() => {
    handleToggleChange();
  }, [contactWindowDetails]);

  const handleToggleone = () => {
    setActiveone(!isActiveone);
  };

  useEffect(() => {
    let response: any = [];
    response = filterFavouriteContacts(allContacs);
    if (Array.isArray(response) && response.length > 0) {
      store.dispatch({
        type: Types.FAV_CONTACT,
        payload: {
          favContacts: response
        }
      });
    }
  }, [allContacs]);
  useEffect(() => {
    if (toastReducer.meetingNotify.title !== undefined) {
      //console.log('toastReducer.meetingNotify -- > -- ', toastReducer.meetingNotify);
      //openNotification('topRight', toastReducer.meetingNotify);
      Meetingnotifications('topRight', toastReducer.meetingNotify, history);
      handelMeetingNotification({});
    }
  }, [toastReducer.meetingNotify])

  useEffect(() => {
    if (initalState?.serverDisconnect) {
      console.log("LOgout 2")
      try {
        //Logout().then(()=>{
        const chatService = new SocketChatService(userInfo().fromID, userInfo().domainId);
        if (chatService.socketConnection) {
          chatService.socketConnection.closeConnection();
        }
        chatService.destroy();
        chatService.eventEmit = null;
        chatService.socketConnection = null;
        Cookie.clear();
        localStorage.clear();
        sessionStorage.clear();
        SocketChatService._instance = null;
        unregister();
        history.push("/login");
        history.replace("/login")
      } catch (error: any) {
        console.log(error, "error")
      }
      //});
    }
  }, [initalState?.serverDisconnect])



  const onUndoClick = () => {
    clearTimeout(toastUndo.callback);
    const socketChat = new SocketChatService(userInfo().fromID, userInfo().domainId);
    socketChat.toggleUndo(true);
    socketChat.toastUndo("", "");

  }

  const OpenChatWindow = () => {
    ChatService.openChatWindow(contactWindowDetails, history);
    ChatService.saveChatHighlight(false, {});
    ChatService.filesHighlight(false, {});
    //ChatService.saveChatHighlight(false,{});
  };

  const closeToast = () => {

    const socketChat = new SocketChatService(userInfo().fromID, userInfo().domainId);

    socketChat.toastUndo("", "")

  }
  const handleRightWindow = (type: any, data?: any) => {
    contactService.contactSideWindow(true, type, data);
    ChatService.openChatWindow(contactWindowDetails);
  };

  return (
    <>
      <div className={styles.mainframe}>
        <div className={styles.framemenu}>
          <MainMenus></MainMenus>
        </div>
        <div className={isActiveone ? `${styles.frameleftsidebar}` :
          `${styles.frameleftsidebar} ${styles.hideframeleftsidebar}`}>
          <div className={styles.mobilemenu} onClick={handleToggleone}><span className="icon_close"></span></div>
          <LeftsideBars></LeftsideBars>
        </div>
        <div className={styles.framemain}>
          <div className={styles.frameheader}>

            <div className={styles.mobilemenu} onClick={handleToggleone}>Menus</div>
            <TopHeader></TopHeader>
          </div>
          <div className={isWindowSlide ? `${styles.framemainsection} 
          ${styles.framecolappse} ` : `${styles.framemainsection} ${"incollapse"} ${'middletabadjust'}`}>
            {isContactWindow &&

              isWindowSlide &&
              <Tooltip mouseEnterDelay={0.5} placement="left" title={isWindowSlide ? 'Click to collapse' : 'Click to expand'}>
                <div className={!isWindowSlide ?
                `${styles.arrowsnav} ${styles.arrowchange}` : `${styles.arrowsnav}`} onClick={handleToggle}>
                <span className="icon_Strokeleftarrow"></span>
              </div>
              
             
            </Tooltip>}
            {contactWindowDetails.caller_id?<div className={styles.chatmainsections}>
              {isContactWindow &&  <URContactsListsMainFrame handleRightWindow={handleRightWindow}
                isActive={isWindowSlide}></URContactsListsMainFrame>}
              {/* {!isContactWindow &&  <> <div className={styles.topsectionssss}>
                <ContactFav favContactlist={favContacts}/>
                
              </div>
              <div className={styles.chatinnerframe}>
                <div className={styles.contactInner}>
                  {teamContacs?.length > 0 &&
                  <div className={styles.teamsSec}>
                    <ContactTeams />
                  </div>}
                  <div className={styles.newMemSec}>
                    <ContactNewMem />
                  </div>
                </div>
              </div></> } */}
             
             
            </div>:
              <div className={styles.contactEmpty}>
                <img src={contactcenterEmpty} alt="" />
              </div>}
            </div>
          {isContactWindow &&<div className={!isWindowSlide ? `${styles.framerightsidebar}
           ${styles.hideframerightsidebar}` : `${styles.framerightsidebar}`}>
            {isKey === 'createNote' && <CreateNote handleToggle={handleToggle}></CreateNote>}
            {isKey === 'editNote' &&
              <CreateNote isEdit={isKey === 'editNote' ? true : false}
                noteData={editData} handleToggle={handleToggle}></CreateNote>}
            {isKey === 'viewNote' &&
              <NoteViewRight handleToggle={handleToggle} noteData={editData} />}

            {isKey === 'createTask' && <CreateTask handleToggle={handleToggle} />}

            {isKey === 'editTask' &&
              <TaskViewDetails taskData={editData} handleToggle={handleToggle}></TaskViewDetails>}

            {isKey === 'createEvent' && <NewEventRightCreate handleToggle={handleToggle}
              module={'contact'}>
            </NewEventRightCreate>}
            {isKey === 'editEvent' && <EditEventRightBar isEdit={editData} handleToggle={handleToggle}
              module={'contact'}>
            </EditEventRightBar>}
            {isKey === 'savedchat' && <div className={styles.mainnames}>
              <h3>{contactWindowDetails.caller_id}</h3>
              <Tooltip mouseEnterDelay={0.5} placement="topRight" title="Go to Chat">
                <span className={`${"icon_popin"} ${styles.popout}`} onClick={() => OpenChatWindow()}></span></Tooltip>
              <div className={`scroller ${styles.chatinnermaindiv}`}>
              </div></div>}

          </div>}

        </div>
      </div>
      {toastReducer.isLeftToast && <ToastLeft />}
      {toastUndo.toastMessage && <ToastUndo undo={true} message={toastUndo.toastMessage}
        onUndoClick={onUndoClick} closeToast={closeToast}></ToastUndo>}
    </>
  );
};

export default React.memo(URContactsMainFrame);